// ** React Imports
import {Fragment, useState, useRef} from 'react'

// ** Third Party Components
import classnames from 'classnames'
import PerfectScrollbar from 'react-perfect-scrollbar'

// ** Vertical Menu Components
import VerticalMenuHeader from './VerticalMenuHeader'
import VerticalNavMenuItems from './VerticalNavMenuItems'

import UILoader from '@components/ui-loader'

import Constant from '@src/utility/Constants'

import {isRestartingAtom, versionAtom} from '@src/utility/atoms'
import {useAtom} from 'jotai'

const Sidebar = props => {
  // ** Props
  const {menuCollapsed, menu, skin, menuData} = props

  // ** States
  const [groupOpen, setGroupOpen] = useState([])
  const [groupActive, setGroupActive] = useState([])
  const [currentActiveGroup, setCurrentActiveGroup] = useState([])
  const [activeItem, setActiveItem] = useState(null)

  // ** Menu Hover State
  const [menuHover, setMenuHover] = useState(false)

  const [isRestarting] = useAtom(isRestartingAtom)

  const [versionMsg] = useAtom(versionAtom)

  // ** Ref
  const shadowRef = useRef(null)

  // ** Function to handle Mouse Enter
  const onMouseEnter = () => {
    setMenuHover(true)
  }

  // ** Scroll Menu
  const scrollMenu = container => {
    if (shadowRef && container.scrollTop > 0) {
      if (!shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.add('d-block')
      }
    } else {
      if (shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.remove('d-block')
      }
    }
  }

  return (
    <Fragment>
      <div
        className={classnames(
          'main-menu menu-fixed menu-accordion menu-shadow',
          {
            expanded: menuHover || menuCollapsed === false,
            'menu-light': skin !== 'semi-dark' && skin !== 'dark',
            'menu-dark': skin === 'semi-dark' || skin === 'dark'
          }
        )}
        onMouseEnter={onMouseEnter}
        onMouseLeave={() => setMenuHover(false)}>
        {menu ? (
          menu({...props})
        ) : (
          <Fragment>
            {/* Vertical Menu Header */}
            <UILoader blocking={isRestarting} loader={<div />}>
              <VerticalMenuHeader
                setGroupOpen={setGroupOpen}
                menuHover={menuHover}
                {...props}
              />
            </UILoader>
            {/* Vertical Menu Header Shadow */}
            <div className="shadow-bottom" ref={shadowRef}></div>
            {/* Perfect Scrollbar */}

            <PerfectScrollbar
              className="main-menu-content"
              options={{wheelPropagation: false}}
              onScrollY={container => scrollMenu(container)}>
              <UILoader blocking={isRestarting} loader={<div />}>
                <ul className="navigation navigation-main">
                  <VerticalNavMenuItems
                    items={menuData.filter(function (option) {
                      //remove alarmsystem-users menu if not supported by version
                      if (
                        option.id == 'alarmsystem' &&
                        versionMsg != null &&
                        versionMsg.sw != '' &&
                        versionMsg.sw < Constant.VER_FILTER_USERS_LIVE
                      ) {
                        console.log(option, versionMsg)

                        for (
                          let index = 0;
                          index < option.children.length;
                          index++
                        ) {
                          const element = option.children[index]
                          if (element.id == 'alarmsystem-users') {
                            console.log(
                              'remove alarmsystem-users',
                              option.id,
                              versionMsg
                            )
                            option.children.splice(index, 1)
                            return false
                          }
                        }
                      }

                      //remove tools-settings menu if not supported by version
                      if (
                        option.id == 'tools' &&
                        versionMsg != null &&
                        versionMsg.sw != '' &&
                        versionMsg.sw < Constant.VER_FILTER_SETTINGS_LIVE
                      ) {
                        console.log(option, versionMsg)

                        for (
                          let index = 0;
                          index < option.children.length;
                          index++
                        ) {
                          const element = option.children[index]
                          if (element.id == 'tools-settings') {
                            console.log(
                              'remove tools-settings',
                              option.id,
                              versionMsg
                            )
                            option.children.splice(index, 1)
                            return false
                          }
                        }
                      }

                      return true
                    })}
                    menuData={menuData}
                    menuHover={menuHover}
                    groupOpen={groupOpen}
                    activeItem={activeItem}
                    groupActive={groupActive}
                    setGroupOpen={setGroupOpen}
                    menuCollapsed={menuCollapsed}
                    setActiveItem={setActiveItem}
                    setGroupActive={setGroupActive}
                    currentActiveGroup={currentActiveGroup}
                    setCurrentActiveGroup={setCurrentActiveGroup}
                  />
                </ul>{' '}
              </UILoader>
            </PerfectScrollbar>
          </Fragment>
        )}
      </div>
    </Fragment>
  )
}

export default Sidebar
